import axios from 'axios';

import { userAccessTokenName } from "./constants";
import {getCookie} from "../utils/useCookies";

export const token = getCookie(userAccessTokenName);

// export let host = "https://api.oqituvchilar.uz";
export let host = "https://api.oqituvchilar.uz";

export let port = '';


export let headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=utf-8',
    'Authorization': token ?`Bearer ${token}`:''
};

export let axiosInstance = axios.create({
    baseURL: `${host}:${port}`,
    headers,
    timeout: 300000,
});
